import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import { AdProviders, adunitMemo, ADUNIT_FALLBACK_MAP, ADUNIT_MAP } from '../../../constants';
import { useAdUnit } from '../../../useAdUnit';
import DealerAdIframe from '../../dealer';
const MobileDevPageSide300x250 = /*#__PURE__*/ React.memo(({ safety ='off'  })=>{
    const _useAdUnit = useAdUnit(AdProviders.Freestar, ADUNIT_MAP['MobileDevPageSide300x250Gam'], safety, {
        targeting: {
            unitType: 'btf'
        }
    }), { advertIsOff  } = _useAdUnit, slotAttr = _object_without_properties(_useAdUnit, [
        "advertIsOff"
    ]);
    if (advertIsOff) {
        return /*#__PURE__*/ React.createElement("div", {
            style: {
                width: '300px',
                height: '250px'
            }
        }, /*#__PURE__*/ React.createElement(DealerAdIframe, {
            realEstateId: ADUNIT_FALLBACK_MAP['MobileDevPageSide300x250Gam'],
            neverCollapse: true,
            fillBlock: true
        }));
    }
    return /*#__PURE__*/ React.createElement("div", _extends({}, slotAttr));
}, adunitMemo);
MobileDevPageSide300x250.displayName = 'MobileDevPageSide300x250';
export default MobileDevPageSide300x250;
